import { useContext, useMemo } from 'react';
import DebugBoundaryVisibleContext from '../internal/provider/DebugBoundaryVisibleContext';
export const ALL_CATEGORIES = '*';
export default function useDebugBoundaryVisible(categories) {
    const [visibleCategories, setVisibleCategories] = useContext(DebugBoundaryVisibleContext);
    const visible = useMemo(()=>{
        if (categories && categories.length > 0) {
            return categories.some((cat)=>visibleCategories.has(cat)) || visibleCategories.has(ALL_CATEGORIES);
        }
        return visibleCategories.size > 0;
    }, [
        visibleCategories,
        categories
    ]);
    const setVisible = useMemo(()=>{
        if (categories && categories.length > 0) {
            return (v)=>{
                setVisibleCategories((prev)=>{
                    const next = new Set(prev);
                    if (v) {
                        next.delete(ALL_CATEGORIES);
                        categories.forEach((cat)=>next.add(cat));
                    } else {
                        categories.forEach((cat)=>next.delete(cat));
                    }
                    return next;
                });
            };
        }
        return (v)=>{
            setVisibleCategories(v ? new Set([
                ALL_CATEGORIES
            ]) : new Set());
        };
    }, [
        setVisibleCategories,
        categories
    ]);
    return [
        visible,
        setVisible
    ];
}

//# sourceMappingURL=useDebugBoundaryVisible.js.map